export default __webpack_public_path__ + "static/PC_4_1-a4a916f2de0de1ba4548d680ca119f2c.png";